import React from 'react'

function SearchBar({label, placeholder, value, setValue, doSearch}) {
  return (
    <div className='w-full flex flex-col py-[2vmax] justify-center items-center'>
            <div className='w-1/2 px-[5vmax] flex justify-start'>
            <label className='text-black text-[1.7vmax] font-semibold'>{label}:</label></div>
            <div>
                <div className='flex'>
            <input onChange={(e)=>{
              setValue(e.target.value);
            }} className='rounded-[0.2vmax] border-4 text-[1.5vmax] w-[40vmax] h-[4vmax] p-[0.5vmax]' placeholder={placeholder} type='text'></input><img onClick={(e)=>{
              e.preventDefault();
              doSearch();
            }} className='searchicon w-[4vmax] my-[0.1vmax] cursor-pointer p-[0.5vmax] h-[4vmax]' src='https://static-00.iconduck.com/assets.00/search-icon-1024x1024-as1y1dr0.png' /></div></div>
    </div>
  )
}

export default SearchBar